module.exports = __webpack_public_path__ + "static/img/run2023_pending.d2553130.jpg";